import React from "react";
import { components as selectComponents } from "react-select";
import { Trash2 } from "lucide-react";
import { toast } from "react-hot-toast";

const DeletableAsyncOption = (props) => {
  const { data, selectProps } = props;
  const { onDeleteOption, deletingOptionId, userPermission } =
    selectProps || {};
  const isDeleting = deletingOptionId === data?.value;

  const handleDelete = (event) => {
    if (userPermission !== "masterAccess") {
      toast.error("You do not have permission to delete");
      return;
    }
    event.stopPropagation();
    if (!onDeleteOption || !data?.value || isDeleting) return;
    onDeleteOption(data);
  };

  return (
    <selectComponents.Option {...props}>
      <div className="flex items-center justify-between gap-2">
        <span className="truncate">{props.children}</span>
        {onDeleteOption && data?.value ? (
          <button
            type="button"
            onClick={handleDelete}
            disabled={isDeleting}
            className="p-1 text-gray-400 hover:text-red-600 disabled:opacity-50"
            aria-label={`Delete ${data.label}`}
          >
            {isDeleting ? (
              <span className="text-xs text-gray-500">Deleting…</span>
            ) : (
              <Trash2 className="h-4 w-4" aria-hidden="true" />
            )}
          </button>
        ) : null}
      </div>
    </selectComponents.Option>
  );
};

export default DeletableAsyncOption;
